<template>
  <v-container fluid class="px-5 pt-3">
    <v-row class="pa-3" align='center'>
      <span class="title font-weight-bold">{{ $t('companies.companies') }}</span>
      <v-spacer></v-spacer>
      <v-btn color="primary" elevation="0" small class="text-capitalize font-weight-bold" style="border-radius: 5px;" :to="{name: 'NewCompany'}" >
        <v-icon left small>mdi-plus</v-icon>
        {{ $t('companies.company') }}
      </v-btn>
    </v-row>
    <!-- <base-page-title title="Cadastro de Companye">
      <template v-slot:actions>
        <f-btn alt_label="Cadastrar de Companye" alt_icon="mdi-plus"></f-btn>
      </template>
    </base-page-title> -->
    <company-list class="mt-5"></company-list>

    <router-view></router-view>
  </v-container>
</template>

<script>
export default {
  name: 'ListCompaniesPage',
  components: {
    CompanyList: () => import('@/components/admin/company/CompanyList.vue'),
  },
}
</script>

<style scoped>

</style>